var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.25C5.12406 3.25 2.59346 4.75071 0.40967 7.53739C0.196777 7.80906 0.196777 8.19094 0.40967 8.46261C2.59346 11.2493 5.12406 12.75 8 12.75C10.8759 12.75 13.4065 11.2493 15.5903 8.46261C15.8032 8.19094 15.8032 7.80906 15.5903 7.53739C13.4065 4.75071 10.8759 3.25 8 3.25ZM8 11.25C5.86468 11.25 3.85471 10.2262 1.96721 8C3.85471 5.77384 5.86468 4.75 8 4.75C10.1353 4.75 12.1453 5.77384 14.0328 8C12.1453 10.2262 10.1353 11.25 8 11.25ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z",
    fill: "#08295C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c9f799af15bfad5b20db3752e1571a8f.svg";
export { ForwardRef as ReactComponent };